document.addEventListener('click', function(e) {
  var tab = e.target.closest('.sg-tab');
  if (!tab) return;
  var popup = tab.closest('.product-sizechart-content');
  if (!popup) return;
  var id = tab.getAttribute('data-id');
  var tabs = popup.querySelectorAll('.sg-tab');
  var secs = popup.querySelectorAll('.sg-sec');
  secs.forEach(function(s) { s.style.setProperty('display', 'none', 'important'); });
  tabs.forEach(function(t) { t.style.color='#888'; t.style.borderBottomColor='transparent'; });
  var clickedIndex = Array.from(tabs).indexOf(tab);
  if (secs[clickedIndex]) secs[clickedIndex].style.setProperty('display', 'block', 'important');
  tab.style.color = '#111';
  tab.style.borderBottomColor = '#111';
});

document.addEventListener('click', function(e) {
  if (!e.target.closest('.open-popup-size-guide')) return;
  setTimeout(function() {
    var popup = document.querySelector('.product-sizechart-content');
    if (!popup) return;
    var secs = popup.querySelectorAll('.sg-sec');
    secs.forEach(function(s, i) {
      s.style.setProperty('display', i === 0 ? 'block' : 'none', 'important');
    });
  }, 500);
});